module.exports = __webpack_public_path__ + "static/media/cactus.1894ecba.svg";